<template>
	<div class="app-container">

		<section class="page">
			
			<header>
				<h1 class="flex-container gap-1rem">
					<span>Search results for</span>
					<SearchResultHighlight class="italic" :textToHighlight="searchString" :searchPhrase="searchString" />
				</h1>
			</header>

			<SearchResultsList :results="results" :searchString="searchString" />
			<ErrorDialog ref="errDialog" />

		</section>

	</div>
</template>

<script>
import Article from "../../../services/article";
import SearchResultsList from "./SearchResultsList";
import ErrorDialog from "../../shared/ErrorDialog";
import SearchResultHighlight from "./SearchResultHighlight";

export default {
	name: "SearchResults",
	components: {
		SearchResultsList,
		ErrorDialog,
		SearchResultHighlight,
	},
	data: function () {
		return {
			results: [],
			searchString: null,
		};
	},
	mounted() {
		this.getSearchResults();
		this.setSearchString();
	},
	watch: {
		"$route.query.search": "handleSearchStringChange",
	},
	methods: {
		handleSearchStringChange: function () {
			this.getSearchResults();
			this.setSearchString();
		},
		getSearchResults: function () {
			let searchText = this.$route.query.search;
			if (!searchText) return;
			let search = {
				page: 0,
				size: 10,
				filter: {
					search: searchText
				}
			}
			Article.instance()
				.searchArticle(search)
				.then((res) => {
					this.results = res.data.content;
					this.results = this.results.filter(
						(a) => a.articleType != "INDEX_PAGE"
					);
				})
				.catch((err) => {
					this.$refs.errDialog.show(err);
				});
		},
		setSearchString: function () {
			this.searchString = this.$route.query.search;
		},
	},
};
</script>

<style scoped>

</style>